import { render } from "./my-old-book-list.vue?vue&type=template&id=2fb0abd3&scoped=true"
import script from "./my-old-book-list.js?vue&type=script&lang=js&external"
export * from "./my-old-book-list.js?vue&type=script&lang=js&external"

import "./my-old-book-list.css?vue&type=style&index=0&id=2fb0abd3&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb0abd3"]])

export default __exports__